import colors from 'globals/colors'
import styled from 'styled-components'
import measures from 'globals/measures'

export const MailsWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`

export const AddMailButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 10px 0 24px;
  padding-right: 11px;

  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

export const AddMailButtonWrappedRight = styled.div`
  display: flex;

  div:first-child {
    margin-right: 16px;
  }
`

export const AddMailButtonWrapperMobile = styled.div`
  display: none;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 19px;

  & > span {
    font-size: 16px;
    font-weight: 600;
    color: ${colors.waterBlue};
    margin-right: 8px;
  }

  & > button {
    width: 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media(max-width: ${measures.mobileThreshold}px) {
    display: flex;
  }
`

